<!--
  ~ Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
  ~ Venelin Iliev <http://veneliniliev.com>
  -->

<div class="modal-header modal-header-rework">
  <h4 class="modal-title">
    <span *ngIf="user">
      {{ 'USERS.USERS_FORM.EDIT' | translate }} <span *ngIf="user?.id">ID:{{ user.id }} </span>
    </span>
    <span *ngIf="!user">{{ 'USERS.USERS_FORM.ADD' | translate }}</span>
  </h4>
  <button type="button" class="close btn-close-templates" aria-label="Close" (click)="modal.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<ng-scrollbar class="modal-body ps">
  <form id="user-form" (ngSubmit)="save()" [formGroup]="form" novalidate>
    <div class="main-info-wrapper">
      <div class="row">
        <div class="col-sm-2 text-center">
          <div
            *ngIf="!form.get('new_avatar').value"
            class="user-avatar-holder"
            [style.background-image]="form.get('avatar').value && getBackgroundImg(form.get('avatar').value)"
          >
            <div
              (click)="clearAvatar()"
              class="btn btn-ico btn-danger delete-avatar"
              *ngIf="form.get('avatar').value || form.get('new_avatar').value"
            >
              <i class="fal fa-times"></i>
            </div>
          </div>

          <div
            *ngIf="form.get('new_avatar').value"
            class="user-avatar-holder"
            [style.background-image]="form.get('new_avatar').value && getBackgroundImg(form.get('new_avatar').value)"
          >
            <div
              (click)="clearAvatar()"
              class="btn btn-ico btn-danger delete-avatar"
              *ngIf="form.get('avatar').value || form.get('new_avatar').value"
            >
              <i class="fal fa-times"></i>
            </div>
          </div>

          <p-fileUpload
            #fileUpload
            mode="basic"
            name="new_avatar"
            [auto]="true"
            [accept]="MediaLibraryAcceptTypes.IMAGES"
            customUpload="true"
            (uploadHandler)="addAvatar($event)"
          ></p-fileUpload>
        </div>

        <div class="col-sm-10">
          <div class="row">
            <div class="col-sm-2">
              <div class="form-group">
                <label>{{ 'USERS.USERS_FORM.TITLE' | translate }}</label>
                <app-type-select
                  [parentFormGroup]="form"
                  [groupType]="'contact_person_title'"
                  [passFormControlName]="'title_id'"
                ></app-type-select>
              </div>
            </div>

            <div class="col-sm-2">
              <div class="form-group">
                <label>{{ 'USERS.USERS_FORM.FAKE_FIRST_NAME' | translate }}</label>
                <input type="text" class="form-control" formControlName="fake_first_name" />
              </div>
            </div>

            <div class="col-sm-2">
              <div class="form-group">
                <label>{{ 'USERS.USERS_FORM.FAKE_LAST_NAME' | translate }}</label>
                <input type="text" class="form-control" formControlName="fake_last_name" />
              </div>
            </div>

            <div class="col-sm-3">
              <div class="form-group">
                <label>{{ 'USERS.USERS_FORM.EMAIL' | translate }}</label>
                <input type="email" autocomplete="new-email" class="form-control" formControlName="email" />
              </div>
            </div>

            <div class="col-sm-3">
              <div class="form-group">
                <label>{{ 'USERS.USERS_FORM.FAKE_EMAIL' | translate }}</label>
                <input type="text" class="form-control" formControlName="fake_email" />
              </div>
            </div>

            <div class="col-sm-2">
              <div class="form-group">
                <label>{{ 'USERS.USERS_FORM.PASSWORD' | translate }}</label>
                <input type="password" autocomplete="new-password" class="form-control" formControlName="password" />
              </div>
            </div>

            <div class="col-sm-5">
              <div class="form-group">
                <label>{{ 'USERS.USERS_FORM.LOCALES' | translate }}</label>
                <app-locales-select [FormControl]="form.get('locales')"></app-locales-select>
              </div>
            </div>

            <div class="col-sm-5">
              <div class="form-group">
                <label>{{ 'USERS.USERS_FORM.COMPANIES' | translate }}</label>
                <app-companies-select [FormControl]="form.get('companies')"></app-companies-select>
              </div>
            </div>

            <div class="col-sm-12">
              <div class="form-group">
                <label>{{ 'USERS.USERS_FORM.ALLOWED_IP_ADDRESSES' | translate }}</label>
                <app-ips-select [parentFormGroup]="form" [passFormControlName]="'allowed_ip_addresses'">
                </app-ips-select>
              </div>
            </div>

            <div class="col-sm-12">
              <div class="form-group">
                <app-contact #contactComp [parentFormGroup]="form" [showNote]="true"></app-contact>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <app-smtp-settings [parentFormGroup]="form"></app-smtp-settings>

    <div *ngIf="accessService.hasAccess([UserRoleType.IT], [])">
      <div class="modal-section-title">{{ 'USERS.USERS_FORM.ROLES' | translate }}</div>

      <div class="roles-wrapper">
        <div class="row">
          <div class="col-sm-2" formArrayName="roles" *ngFor="let role of form.get('roles')?.controls; let i = index">
            <div class="custom-control custom-checkbox">
              <input
                type="checkbox"
                class="custom-control-input"
                [attr.id]="'role' + '-' + role.get('id').value"
                [formControl]="role.get('selected')"
              />
              <label class="custom-control-label" [attr.for]="'role' + '-' + role.get('id').value">
                {{ role.get('name').value }}
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="d-flex justify-content-between">
      <div
        *ngIf="accessService.hasAccess([UserRoleType.FINANCE_AGENT, UserRoleType.FINANCE_MANAGER], [])"
        class="custom-control custom-checkbox mt-2 employee-custom-checkbox"
      >
        <input
          type="checkbox"
          class="custom-control-input"
          formControlName="employee"
          id="employee"
          (change)="employeeBoolChange()"
        />
        <label class="custom-control-label" for="employee">
          {{ 'USERS.USERS_FORM.EMPLOYEE' | translate }}
        </label>
      </div>

      <div class="custom-control custom-checkbox mt-2 me-2">
        <input
          type="checkbox"
          class="custom-control-input"
          formControlName="enable_notifications"
          id="user-enable-notifications"
        />
        <label class="custom-control-label" for="user-enable-notifications">
          {{ 'USERS.USERS_FORM.ENABLE_NOTIFICATIONS' | translate }}
        </label>
      </div>

      <div class="custom-control custom-checkbox mt-2 me-2">
        <input type="checkbox" class="custom-control-input" formControlName="active" id="user-active" />
        <label class="custom-control-label" for="user-active">
          {{ 'USERS.USERS_FORM.ACTIVE' | translate }}
        </label>
      </div>
    </div>

    <div
      class="employee-data-wrapper"
      *ngIf="
        form.get('employee').value &&
        accessService.hasAccess([UserRoleType.FINANCE_AGENT, UserRoleType.FINANCE_MANAGER], [])
      "
    >
      <div class="row">
        <div class="col-sm-2">
          <app-company-select [parentFormGroup]="form"></app-company-select>
        </div>

        <div class="col-sm-3">
          <div class="form-group">
            <label>{{ 'USERS.USERS_FORM.FIRST_NAME' | translate }}</label>
            <input type="text" class="form-control" formControlName="first_name" />
          </div>
        </div>

        <div class="col-sm-3">
          <div class="form-group">
            <label>{{ 'USERS.USERS_FORM.MIDDLE_NAME' | translate }}</label>
            <input type="text" class="form-control" formControlName="middle_name" />
          </div>
        </div>

        <div class="col-sm-3">
          <div class="form-group">
            <label>{{ 'USERS.USERS_FORM.LAST_NAME' | translate }}</label>
            <input type="text" class="form-control" formControlName="last_name" />
          </div>
        </div>

        <div class="col-sm-1">
          <div class="form-group">
            <label>{{ 'USERS.USERS_FORM.POST_CODE' | translate }}</label>
            <input type="text" class="form-control" formControlName="post_code" />
          </div>
        </div>

        <div class="col-sm-4">
          <div class="form-group">
            <label>{{ 'USERS.USERS_FORM.ADDRESS' | translate }}</label>
            <input type="text" class="form-control" formControlName="address" />
          </div>
        </div>

        <div class="col-sm-3">
          <div class="form-group">
            <label>{{ 'USERS.USERS_FORM.ADDRESS2' | translate }}</label>
            <input type="text" class="form-control" formControlName="address2" />
          </div>
        </div>

        <div class="col-sm-2">
          <div class="form-group">
            <label>{{ 'USERS.USERS_FORM.EGN' | translate }}</label>
            <input type="text" class="form-control" formControlName="egn" />
          </div>
        </div>

        <div class="col-sm-2">
          <div class="form-group">
            <label>{{ 'USERS.USERS_FORM.BIRTHDATE' | translate }}</label>
            <!--            <input type="text" class="form-control" formControlName="birthdate" />-->
            <app-date-picker [FormControl]="form.get('birthdate')" [yearsRange]="60"></app-date-picker>
          </div>
        </div>

        <div class="col-sm-1">
          <div class="form-group">
            <label>{{ 'USERS.USERS_FORM.GENDER' | translate }}</label>
            <select class="form-control" formControlName="gender">
              <option value="f">{{ 'USERS.USERS_FORM.FEMALE' | translate }}</option>
              <option value="m">{{ 'USERS.USERS_FORM.MALE' | translate }}</option>
            </select>
          </div>
        </div>

        <div class="col-sm-1">
          <div class="form-group">
            <label>{{ 'USERS.USERS_FORM.LUNCH_BREAK' | translate }}</label>
            <!--            <input type="text" class="form-control" formControlName="lunch_break"/>-->
            <app-time-picker [FormControl]="form.get('lunch_break')"></app-time-picker>
          </div>
        </div>

        <div class="col-sm-2">
          <div class="form-group">
            <label>{{ 'USERS.USERS_FORM.WORKING_HOURS_PER_WEEK' | translate }}</label>
            <input type="number" class="form-control" formControlName="working_hours_per_week" />
          </div>
        </div>

        <div class="col-sm-2">
          <div class="form-group">
            <label>{{ 'USERS.USERS_FORM.WORKING_TIME_FROM' | translate }}</label>
            <!--            <input type="text" class="form-control" formControlName="working_time_from"/>-->
            <app-time-picker [FormControl]="form.get('working_time_from')"></app-time-picker>
          </div>
        </div>

        <div class="col-sm-2">
          <div class="form-group">
            <label>{{ 'USERS.USERS_FORM.WORKING_TIME_TO' | translate }}</label>
            <!--            <input type="text" class="form-control" formControlName="working_time_to"/>-->
            <app-time-picker [FormControl]="form.get('working_time_to')"></app-time-picker>
          </div>
        </div>

        <div class="col-sm-2">
          <app-cities-select [parentFormGroup]="form"></app-cities-select>
        </div>

        <div class="col-sm-3">
          <div class="form-group">
            <label>{{ 'USERS.USERS_FORM.SALARY_PAYMENT_METHOD_ID' | translate }}</label>
            <app-type-select
              [parentFormGroup]="form"
              [groupType]="'payment_method'"
              [passFormControlName]="'salary_payment_method_id'"
            ></app-type-select>
          </div>
        </div>

        <div class="col-sm-2">
          <div class="form-group">
            <label>{{ 'USERS.USERS_FORM.CONTRACT_START_DATE' | translate }}</label>
            <app-date-picker [FormControl]="form.get('contract_start_date')"></app-date-picker>
          </div>
        </div>

        <div class="col-sm-2">
          <div class="form-group">
            <label>{{ 'USERS.USERS_FORM.CONTRACT_END_DATE' | translate }}</label>
            <app-date-picker [FormControl]="form.get('contract_end_date')" [required]="false"></app-date-picker>
          </div>
        </div>

        <div
          class="col-sm-2"
          *ngIf="
            !env.production ||
            this.authenticationService.accessToken.profile.id == UsersEnum.tess ||
            this.authenticationService.accessToken.profile.id == UsersEnum.vanelin ||
            accessService.hasRole(number(UserRoleType.FINANCE_MANAGER))
          "
        >
          <div class="form-group">
            <label>{{ 'USERS.USERS_FORM.BASE_SALARY_AMOUNT' | translate }}</label>
            <input type="number" class="form-control" formControlName="base_salary_amount" />
          </div>
        </div>

        <div class="col-sm-6">
          <app-bank-data [parentFormGroup]="form"></app-bank-data>
        </div>
      </div>
    </div>
  </form>
</ng-scrollbar>

<div class="modal-footer">
  <button type="submit" class="btn btn-outline-dark btn-xs" form="user-form" [disabled]="form.invalid">
    {{ 'USERS.USERS_FORM.SAVE' | translate }}
  </button>
</div>
